import React from "react";
import PropTypes from "prop-types";
// react component for creating dynamic tables
import ReactTable from "react-table";
import { observer, inject } from 'mobx-react';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Add from "@material-ui/icons/Add";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import Visibility from "@material-ui/icons/Visibility";
import Close from "@material-ui/icons/Close";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { Tooltip } from '@material-ui/core';
import Swal from 'sweetalert2';
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';

const styles = {
  ...buttonStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

class Media extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      open: false,
      videoUrl: '',
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  async componentDidMount() {
    try {
      await this.props.media.loadMedia();
    } catch (error) {
      this.setState({
        alert: (
          <SweetAlert
            error
            style={{ display: "block", marginTop: "-100px" }}
            title={`Error !`}
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {`${error.message}`}
          </SweetAlert>
        )
      });
    }
  }

  onDeleteClick = id => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true,
      reverseButtons: true,
      preConfirm: async () => {
        return await this.props.media.deleteMedia(id)
          .then(response => {
            if (response) { return response } else { throw response }
          })
          .catch(error => {
            Swal.showValidationMessage(error.message)
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        Swal.fire('Deleted!', '', 'success');
      }
    })
  };

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  handleClickOpen = (url) => {
    this.setState({ videoUrl: url });
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    let { mediaList } = this.props.media;
    let dataMedia = []
    if(mediaList.length){
      dataMedia = (mediaList).map((prop, key) => {
        return {
          id: prop.id,
          no: key,
          name: prop.name,
          url: prop.url,
          thumbnail: (
            <div style={{  width:'100%',height:'100px'}}>
            <img src={prop.thumbnail} height="100%" alt='...' />
            </div>
          ),
          startDate: moment(prop.start_date).local().format("YYYY-MM-DD"),
          actions: (
            <div className="actions-center">
              <Tooltip title="View Media" placement="top">
                <Button
                  justIcon
                  round
                  // simple
                  onClick={() => {
                    let obj = dataMedia.find(o => o.no === key);
                    this.handleClickOpen(obj.url)
                  }}
                  color="primary"
                  className="play">
                  <PlayArrowIcon />
                </Button>
              </Tooltip>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Edit Media" placement="top">
                <Button
                  justIcon
                  round
                  // simple
                  onClick={() => {
                    let obj = dataMedia.find(o => o.no === key);
                    this.props.history.push(`/admin/media/${obj.id}/edit`)
                  }}
                  color="warning"
                  className="edit">
                  <Edit />
                </Button>
              </Tooltip>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Delete" placement="top">
                <Button
                  justIcon
                  round
                  // simple
                  onClick={() => {
                    let obj = dataMedia.find(o => o.no === key);
                    this.onDeleteClick(obj.id)
                  }}
                  color="danger"
                  className="remove">
                  <Close />
                </Button>
              </Tooltip>
            </div>
          )
        };
      });
    }


    return (
      <GridContainer>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {'Video'}
          </DialogTitle>
          <DialogContent>
            <video width="100%" controls>
              <source src={this.state.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
              </video>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="danger" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {this.state.alert}
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Person />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Media List</h4>
              <CardIcon onClick={() => { this.props.history.push(`/admin/media/create`) }} color="info" style={{ float: 'right', borderRadius: '35px', cursor: 'pointer' }}>
                <Add /> <div style={{ float: 'right', paddingTop: '7px', fontWeight: 'bold', paddingRight: '6px' }}>Create Media</div>
              </CardIcon>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={dataMedia}
                filterable
                columns={[
                  {
                    Header: "ID",
                    accessor: "id",
                    width: 80
                  },
                  {
                    Header: "Name",
                    accessor: "name"
                  },
                  {
                    Header: "Thumbnail",
                    accessor: "thumbnail",
                    sortable: false,
                    filterable: false
                  },
                  {
                    Header: "On Air",
                    accessor: "startDate",
                  },
                  {
                    Header: "Actions",
                    headerStyle: { textAlign: 'center' },
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

Media.propTypes = {
  classes: PropTypes.object
};

export const page = inject('media')(observer(Media));
export default withStyles(styles, { withTheme: true })(page);